<dsh-filter
    *transloco="let t; scope: 'invoices-filter'; read: 'invoicesFilter'"
    [active]="isActive"
    [label]="t('label')"
    [activeLabel]="t('activeLabel') | listLabel: savedValue:0"
    [content]="content"
    (save)="save()"
    (clear)="clear()"
></dsh-filter>
<ng-template #content><dsh-invoices-field [formControl]="control"></dsh-invoices-field></ng-template>
